import { message, Modal } from 'hljd'
import http from '@core/fetch'
import { isTelSaleCityMerchant } from './merchantInfo'

const postJob = (isUltimate = false) => {
  return http.post(
    '/p/wedding/Admin/APIMerchantPro/sendInvitationToOpenOaJob',
    {
      body: { isUltimate }
    }
  )
}

/**
 * 购买尊享版
 */
export const buyZunXiang = async () => {
  const {
    data: { isLately, content },
    success
  } = await http('/p/wedding/Admin/APIMerchantPro/isLatelySend')
  if (success) {
    // 是否30天内点击 1是 0否
    if (isLately == 1) {
      Modal.confirm({
        title: content,
        onOk: () => {
          postJob()
        }
      })
    } else {
      Modal.warning({ title: content, okText: '确认', onOk: () => postJob() })
    }
  }
}

/**
 * 电销城市相关类目未开通尊享版
 */
export const checkIsZunXiang = () => {
  // 非电销城市 return
  if (!isTelSaleCityMerchant()) {
    return
  }

  Modal.warning({
    title:
      '您尚未开通尊享版，无法使用此功能。请保持XXXXXXXXXX电话畅通，稍后会有工作人员与您联系',
    onOk: () => {
      postJob()
    }
  })

  Modal.confirm({
    title:
      '您尚未开通尊享版，无法使用此功能。点击确认按钮，并保持XXXXXXXXXX电话畅通，稍后会有工作人员与您联系。',
    onOk: () => {
      postJob()
    }
  })
}

/**
 * 购买旗舰版
 */
export const buyUltimate = async () => {
  const key = new Date().getTime()
  message.loading({ key: key, content: '提交中...' })
  const postJobWait = postJob(true)
  const contentWait = http(
    '/p/wedding/Admin/APIMerchantPro/isLatelySend?isUltimate=true'
  )
  await postJobWait
  const {
    data: { content }
  } = await contentWait
  message.destroy(key)
  Modal.info({
    title: '提交成功',
    content: content
  })
}
